<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BidForm" });
import { Form } from "../../../../components/index.js";
import { createEventDispatcher } from "svelte";
const dispatch = createEventDispatcher();
import * as API from "../../services/api.js";
export let bid = {};
export let action = "create";
export let beforeSave = () => {
};
let formElement = null;
const onSave = (response) => {
    if ("code" in response) {
        return;
    }
    dispatch("save", response);
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        onSave(await API.updateBid({ bidKey: bid._.key }, bid));
        return;
    }
    onSave(await API.createBid(bid));
};
export const submit = async () => {
    if (formElement === null) {
        return;
    }
    await formElement.submit();
};
export const reset = () => {
    formElement?.reset();
};
export const isValid = () => {
    if (formElement === null) {
        return true;
    }
    return formElement.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-bid` } bind:this = { formElement }>

    <slot>
        <h3>{ action } Bid</h3>
        <pre>{ JSON.stringify(bid, null, 2) }</pre>
    </slot>

</Form>